module.exports = __webpack_public_path__ + "img/4-1_05.4505d8f7.jpg";